// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';

// contants
import { HIDE_SCROLLBARS } from 'shared/styles/base';

export const OverlaySheet = styled(BaseOverlaySheet)`
  top: 0;
  left: max(
    70%,
    calc(70% + calc(30% - 400px))
  ); // this is to make the side sheet responsive so it take up 70% of the screen width and max 400px
  height: 100%;
  width: 30%;
  max-width: 400px;
  overflow: hidden;
  ${({ theme }) => `
    border-radius: ${theme.borders.radiusNone};
    background-color: ${theme.colors.surface};
  `};
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  ${HIDE_SCROLLBARS};
`;
